<div class="row table-container" *ngIf="tableData">
	<!-- LEFT TABLE -->
	<div class="left-table" [class.shadow]="this.numberOfPortfolios > componentBreakpoint" [ngClass]="rightColClass" data-cy="hl-holdings-table-left-table">
		<table [ngStyle]="config.styleAttributes?.leftTable ? config.styleAttributes.leftTable : ''">
			<thead *ngIf="showTableHeaders">
				<ng-container *ngIf="reserveFirstCol; else defaultHeaderRow">
					<tr #leftTableHeader class="text-14-bold heading-row">
						<th class="cell heading-cell primary-heading-cell" [style.width.%]="config.header.leftTableHeaderConfigs[0].widthPct" id="icon">
							<div>
								{{ config.header.leftTableHeaderConfigs[0].label }}
							</div>
						</th>
						<th
							*ngFor="let heading of config.header.leftTableHeaderConfigs | slice: 1"
							class="cell heading-cell primary-heading-cell"
							[style.width.%]="heading.widthPct"
							[attr.id]="heading.label"
						>
							<div dcrHTMLKey="{{ heading.dcrHTMLKey }}">
								<span>
									{{ heading.label }}
								</span>
							</div>
						</th>
					</tr>
				</ng-container>

				<ng-template #defaultHeaderRow>
					<tr #leftTableHeader class="text-14-bold heading-row">
						<th
							*ngFor="let heading of config.header.leftTableHeaderConfigs"
							class="cell heading-cell primary-heading-cell"
							[style.width.%]="heading.widthPct"
							[attr.id]="heading.label"
						>
							<div dcrHTMLKey="{{ heading.dcrHTMLKey }}">
								<span>
									{{ heading.label }}
								</span>
							</div>
						</th>
					</tr>
				</ng-template>
			</thead>

			<ng-container *ngFor="let category of categoryIndexMap | keyvalue: zeroSort; index as categoryIndex">
				<tbody
					measure-child-elements
					[querySelector]="'tr.data-row'"
					[propertyToMeasure]="'offsetHeight'"
					[index]="categoryIndex"
					(onWindowResize)="onHoldingsRowHeightChange($event)"
				>
					<tr class="asset-category-row" [ngStyle]="{ 'border-color': colorsConfig[category.key] }">
						<!-- Just here to leave some space for the reserveFirstCol -->
						<th *ngIf="showTableHeaders && reserveFirstCol"></th>
						<th
							class="text-20-bold cell heading-cell"
							id="{{ category.key }}"
							[attr.colspan]="assetCategoryColSpan"
							attr.data-cy="hl-holdings-table-left-table-asset-category-{{ category.key }}"
						>
							<!-- asset category  -->
							<div class="vertical-stretcher">
								{{ category.key }}
							</div>
						</th>
					</tr>

					<ng-container *ngIf="!hideChildrenRows">
						<ng-container *ngFor="let assetIndex of category.value; index as assetIndexIndex">
							<tr class="text-14 data-row" [ngClass]="{ 'data-row-grey': assetIndexIndex % 2 === 0 }">
								<td *ngIf="reserveFirstCol" class="cell data-cell" headers="icon">
									<ng-container
										*ngTemplateOutlet="iconCell; context: { heading: config.header.leftTableHeaderConfigs[0], category: category, assetIndex: assetIndex }"
									></ng-container>
								</td>
								<td
									headers="{{ idHeader?.label }} {{ category.key }}"
									class="cell data-cell"
									attr.data-cy="hl-holdings-table-left-table-holding-{{ idHeader?.label }}-{{ category.key }}-{{ assetIndexIndex }}"
								>
									<!-- identifier -->
									<div class="vertical-stretcher">
										{{ tableData.headersY[assetIndex]?.formattedValue }}
									</div>
								</td>
								<td
									headers="{{ descriptionHeader?.label }} {{ category.key }}"
									class="cell data-cell"
									attr.data-cy="hl-holdings-table-left-table-holding-{{ descriptionHeader?.label }}-{{ category.key }}-{{ assetIndexIndex }}"
								>
									<!-- description -->
									<div class="vertical-stretcher" *ngIf="config.options?.showProductPageLinks; else descriptionSansLink">
										<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
										<a
											class="text-bold"
											[href]="populatePageUrl(assetIndex)"
											target="_blank"
											*ngIf="productIdPerTickerMap.get(tableData.headersY[assetIndex]?.formattedValue); else descriptionSansLink"
											[attr.data-link-event]="tableData.cells[assetIndex][holdingDescriptionIndex]?.formattedValue | analyticEventEvaluatorPipe"
										>
											{{ tableData.cells[assetIndex][holdingDescriptionIndex]?.formattedValue }}
											<span *ngIf="HoldingsTableUtil.shouldDisplaySecurityParametricIndicators(tableData.cells[assetIndex])">*</span>
										</a>
									</div>

									<ng-template #descriptionSansLink>
										<div class="vertical-stretcher">
											{{ tableData.cells[assetIndex][holdingDescriptionIndex]?.formattedValue }}
											<span *ngIf="HoldingsTableUtil.shouldDisplaySecurityParametricIndicators(tableData.cells[assetIndex])">*</span>
										</div>
									</ng-template>
								</td>

								<!-- All other remaining table headers -->
								<ng-container *ngIf="showTableHeaders && config.header.leftTableHeaderConfigs.length > 2">
									<td *ngFor="let heading of config.header?.leftTableHeaderConfigs | slice: (reserveFirstCol ? 3 : 2)" class="cell data-cell">
										<ng-container
											*ngTemplateOutlet="
												isIconTableHeader(heading) ? iconCell : defaultCell;
												context: { heading: heading, category: category, assetIndex: assetIndex }
											"
										></ng-container>
									</td>
								</ng-container>
							</tr>

							<tr *ngIf="selectedExpandedRow.category === category.key && selectedExpandedRow.rowIndex === assetIndex" class="expanded-row">
								<td *ngIf="reserveFirstCol"></td>
								<td [attr.colspan]="assetCategoryColSpan">
									<ng-container *ngTemplateOutlet="config.rowExpansionConfig?.rightTemplate"></ng-container>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</ng-container>
		</table>
	</div>

	<!-- RIGHT TABLE -->
	<div
		class="right-table"
		*ngIf="!hideRightTable"
		[ngClass]="{ 'right-table-four-plus': this.numberOfPortfolios > componentBreakpoint }"
		[class]="leftColClass"
		data-cy="hl-holdings-table-right-table"
	>
		<table class="scrolling-table" [ngStyle]="{ display: scrollingTableDisplayType }" (scroll)="onScroll($event)" #scrollableTable>
			<!-- Asset Class Header Row -->
			<thead class="portfolio" *ngIf="showTableHeaders">
				<tr #rightTableHeader class="text-14-bold">
					<ng-container *ngIf="!enableBlending">
						<ng-container *ngFor="let portfolio of tableData.headersX">
						<!-- Portfolio name if usePortfolioNameHeaders-->
						<th
							*ngIf="config.header?.usePortfolioNameHeaders && portfolio?.formattedValue"
							id="{{ portfolio.formattedValue }}"
							class="cell heading-cell numerical primary-heading-cell"
							[ngStyle]="{ 'text-align': getTextAlignOverride() }"
						>
							<div>
								{{ portfolio.formattedValue }}
							</div>
						</th>
					</ng-container>
					</ng-container>
					<ng-container *ngIf="enableBlending">
						<ng-container *ngFor="let portfolio of data.portfolioData">
						<!-- Portfolio name if usePortfolioNameHeaders-->
						<th
							*ngIf="config.header?.usePortfolioNameHeaders && portfolio.field['name'].formattedValue"
							id="{{ portfolio.field['name'].formattedValue }}"
							class="cell heading-cell numerical primary-heading-cell"
							[ngStyle]="{ 'text-align': getTextAlignOverride() }"
						>
							<div>
								{{ portfolio.field['name'].formattedValue }}
							</div>

							<a
								class="view-structure-button"
								*ngIf="showPortfolioStructureInfo.includes(portfolio.field['id'].rawValue)"
								(click)="showPortfolioStructurInfoDialog(portfolio.field['id'].rawValue)"
								><icon type="sitemap"></icon><span class="icon-caption text-14-bold" dcrHTMLKey="VIEW_STRUCTURE_BUTTON_LABEL">View Structure</span></a
							>
						</th>
					</ng-container>
					</ng-container>
	
					<!-- if !usePortfolioNameHeaders you will only see these-->
					<ng-container *ngIf="config.header?.rightTableHeaderConfigs?.length">
						<th
							*ngFor="let heading of config.header.rightTableHeaderConfigs"
							class="cell heading-cell numerical primary-heading-cell"
							[ngStyle]="{ 'text-align': getTextAlignOverride() }"
							[style.width.%]="heading.widthPct"
						>
							{{ heading.label }}
						</th>
					</ng-container>
				</tr>
			</thead>

			<ng-container *ngFor="let category of categoryIndexMap | keyvalue: zeroSort; index as categoryIndex">
				<!-- Each asset class has its own tbody -->
				<tbody>
					<!-- asset class weighting per portfolio  -->
					<tr class="asset-category-row" [ngStyle]="{ 'border-color': colorsConfig[category.key] }">
						<ng-container *ngFor="let portfolioId of tableData.portfolioData; index as j">
							<td
								class="text-20-bold cell heading-cell numerical"
								headers="{{ portfolioId?.formattedValue }}"
								[ngStyle]="{ 'text-align': getTextAlignOverride() }"
								attr.data-cy="hl-holdings-table-right-table-asset-category-row-{{ portfolioId?.formattedValue }}-{{ categoryIndex }}"
							>
								<div class="vertical-stretcher">
									<ng-container *ngIf="config.options?.replaceZeroWithDash && categoryWeightMap.get(category.key)[j] === 0; else numericalValue">
										-
									</ng-container>
									<ng-template #numericalValue>
										{{ categoryWeightMap.get(category.key)[j] | number: decimalPipeDigitsInfo }}
										<span *ngIf="config.options?.showPercentageSymbol && !!categoryWeightMap.get(category.key)[j]">%</span>
									</ng-template>
								</div>
							</td>
						</ng-container>
						<ng-container *ngFor="let nonPortfolioCol of config?.header?.rightTableHeaderConfigs">
							<td class="text-20-bold cell heading-cell" headers="{{ nonPortfolioCol?.label }}" [ngStyle]="{ 'text-align': getTextAlignOverride() }"></td>
						</ng-container>
					</tr>

					<ng-container *ngIf="!hideChildrenRows">
						<!-- Rows for each asset in the asset class-->
						<ng-container *ngFor="let assetIndex of category.value; index as assetIndexIndex">
							<!-- Set the row heights based on their matching row in the left table -->
							<tr
								class="text-14 data-row"
								[ngClass]="{ 'data-row-grey': assetIndexIndex % 2 === 0 }"
								[style.height.px]="holdingRowsHeights[categoryIndex][assetIndexIndex]"
							>
								<ng-container *ngFor="let portfolioId of tableData.portfolioData; index as portfolioIdIndex">
									<!-- weighting per asset -->
									<td
										headers="{{ portfolioId.formattedValue }}"
										class="cell data-cell numerical"
										[ngStyle]="{ 'text-align': getTextAlignOverride() }"
										attr.data-cy="hl-holdings-table-right-table-asset-row-{{ portfolioId?.formattedValue }}-{{ assetIndexIndex }}-{{ portfolioIdIndex }}"
									>
										<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
										<div class="vertical-stretcher" [ngClass]="getCellClass(assetIndex, portfolioIdIndex)">
											{{
												tableData.cells[assetIndex][tableData.cells[assetIndex].length - (tableData.portfolioData.length - portfolioIdIndex)].formattedValue
											}}
										</div>
									</td>
								</ng-container>

								<!-- custom headers -->
								<ng-container>
									<td *ngFor="let heading of config.header?.rightTableHeaderConfigs" class="cell data-cell">
										<ng-container
											*ngTemplateOutlet="
												isIconTableHeader(heading) ? iconCell : defaultCell;
												context: { heading: heading, category: category, assetIndex: assetIndex }
											"
										></ng-container>
									</td>
								</ng-container>
							</tr>
							<tr *ngIf="selectedExpandedRow.category === category.key && selectedExpandedRow.rowIndex === assetIndex" class="expanded-row">
								<td attr.colspan="{{ numberOfPortfolios + config.header?.rightTableHeaderConfigs?.length }}">
									<ng-container *ngTemplateOutlet="config.rowExpansionConfig?.leftTemplate"> </ng-container>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</ng-container>
		</table>
	</div>
</div>

<ng-template #defaultCell let-heading="heading" let-assetIndex="assetIndex">
	<div class="vertical-stretcher">{{ tableData.cells[assetIndex][heading.dataIndex]?.formattedValue }}</div>
</ng-template>

<ng-template #iconCell let-heading="heading" let-category="category" let-assetIndex="assetIndex">
	<div class="vertical-stretcher icon-container">
		<ng-container *ngFor="let icon of heading.icons">
			<icon
				*ngIf="icon.constraint(category, assetIndex)"
				[type]="icon.iconType"
				[ngClass]="icon.cssClasses"
				(click)="icon.clickHandler && icon.clickHandler(category.key, assetIndex)"
				[tooltip-dcr]="icon.tooltipDcr"
				[tooltip-hover]="true"
				[tooltip-position]="TooltipPosition.TOP"
			></icon>
		</ng-container>
	</div>
</ng-template>
